import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentWaybillStatusHistoryFacade } from './shipment-waybill-status-history.facade';
import { WaybillIdView } from '../../../../models';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillStatusHistoryGuard {
  constructor(
    private shipmentWaybillStatusHistoryFacade: ShipmentWaybillStatusHistoryFacade,
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$.pipe(
      switchMap((identifier: WaybillIdView) => {
        return loadStoreState(this.shipmentWaybillStatusHistoryFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillStatusHistoryFacade);
  }
}
